import { Builder } from '@builder.io/react';
import classNames from 'classnames';
import React, { FC, useContext } from 'react';
import TopbarTransparencyContext from '../../../context/TopbarTransparencyContext';
import { ROUTE_NAMES, ROUTES } from '../../../routes/routeConstants';
import NamedLink, { NamedLinkProps } from '../../NamedLink/NamedLink';
import TypographyWrapper, { TypographyFormat } from '../../TypographyWrapper/TypographyWrapper';
import css from '../TopbarDesktop.module.css';

type CustomTopbarLinkProps = {
  text: string;
  namedLinkProps: NamedLinkProps;
};

export const CustomTopbarLinkInputs = [
  {
    name: 'text',
    type: 'string',
    required: true,
    defaultValue: 'Change Me',
  },
  {
    name: 'namedLinkProps',
    type: 'object',
    defaultValue: {
      name: ROUTES.LandingPage.name,
    },
    subFields: [
      {
        name: 'name',
        type: 'string',
        required: true,
        enum: ROUTE_NAMES,
      },
      {
        name: 'to',
        type: 'object',
        subFields: [
          {
            name: 'search',
            type: 'string',
          },
        ],
      },
    ],
  },
];

export const CustomTopbarLink: FC<CustomTopbarLinkProps> = ({ text, namedLinkProps }) => {
  const { isTransparentTopbar } = useContext(TopbarTransparencyContext);

  return (
    <div className={css.sectionWrapper}>
      <NamedLink
        className={classNames(css.sectionLink)}
        name={namedLinkProps.name}
        to={{
          search: namedLinkProps.to?.search,
        }}
      >
        <span
          className={classNames(css.label, {
            [css.transparentTopbarForeground]: isTransparentTopbar,
          })}
        >
          <TypographyWrapper variant="subtitle1" format={TypographyFormat.HoverUnderlined}>
            {text}
          </TypographyWrapper>
        </span>
      </NamedLink>
    </div>
  );
};
